/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunktionsbereichFreigabe { 
    funktionsbereich_id: string;
    explizite_freigabe_erforderlich?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

